import React from 'react'

export const Header = () => {
    return (
        <header className="bg-info text-white p-2">
            <div className="container-fluid">
                <h2>React Shopping Cart</h2>
            </div>
        </header>
    )
}
